(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bar-chart"] && !Shopify.designMode) return;
  try {
    
  // In View
  const inViewItems = $(".set-in-view");
  // console.log(inViewItems)

  const inViewObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('in-view');
        inViewObserver.unobserve(entry.target);
      }
    })
  }, {
    threshold: .5
  });

  inViewItems.each(item => {
    inViewObserver.observe(inViewItems[item]);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-cat-carousel"] && !Shopify.designMode) return;
  try {
    
  $('.slick-slider.progress-dots').slick()
  // Slideshow Events
  $('.slick-slider.progress-dots').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $(this).css({ '--progress': nextSlide });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["blog-cat-collage"] && !Shopify.designMode) return;
  try {
    
  $('.slick-slider.progress-dots').slick()

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-featured-collection"] && !Shopify.designMode) return;
  try {
    
  $('.slick-slider.progress-dots').slick();
  // Slideshow Events
  $('.slick-slider.progress-dots').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $(this).css({ '--progress': nextSlide });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection-carousel"] && !Shopify.designMode) return;
  try {
    
  $('.slick-slider.progress-dots').slick();
  // Slideshow Events
  $('.slick-slider.progress-dots').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $(this).css({ '--progress': nextSlide });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collection"] && !Shopify.designMode) return;
  try {
    
  if ($('.featured-collection-slider.progress-dots')) {
    $('.featured-collection-slider.progress-dots').slick();

    console.log('slider: ',$('.progress-dots'));
    // Slideshow Events
    $('.featured-collection-slider.progress-dots').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $(this).css({ '--progress': nextSlide });
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  $('#siteCreditTrigger').click(() => {
    // console.log($('#siteCreditBar')[0])
    $('#siteCreditBar').toggleClass('open');
    setTimeout(() => {
      window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' })
    }, 300);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    

	class StickyHeader extends HTMLElement {
		constructor() {
			super();
		}

		connectedCallback() {
			this.header = document.getElementById('shopify-section-header');
			this.headerBounds = {};
			this.onScrollHandler = this.onScroll.bind(this);
			window.addEventListener('scroll', this.onScrollHandler, false);
		}

		onScroll() {
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

			if (scrollTop > 80) {
				this.header.classList.add('scrolled');
			} else {
				this.header.classList.remove('scrolled');
			}
		}
	}

	customElements.define('sticky-header', StickyHeader);

	$('#searchToggle').click(() => {
		$('#shopify-section-header').toggleClass('searching');
		$('#searchForm, #searchForm-dame15').toggleClass('collapsed');
		$('#searchToggle').toggleClass('expanded');
		$('#searchForm input.search__input.field__input').focus();
	});

	$('#shopify-section-header').mouseleave(function() {
		if ($('#searchToggle').hasClass('expanded')) {
			$('#searchForm, #searchForm-dame15').addClass('collapsed');
			$('#searchToggle').removeClass('expanded');
			$('#shopify-section-header').removeClass('searching');
		}
	});

	$('.mobile-main-menu [data-trigger]').click((e) => {
        e.preventDefault();

		const $trigger = $(e.currentTarget);
		const target = $trigger.data('trigger');
		const $target = $('.mobile-main-menu').find(`[data-target="${target}"]`);

		if ($target.length) {
			if ($trigger.parent().hasClass('active')) {
				$trigger.parent().removeClass('active');
				$target.removeClass('active');
				$('.mobile-main-menu').removeClass('opened');

				// this.$currentActive = null;
			} else {
				$trigger.parent().addClass('active');
				$target.addClass('active');
				$('.mobile-main-menu').addClass('opened');

				// this.$currentActive = $target;
			}
		}
	});
    $('.back-to a').click((e) => {
        e.preventDefault();

        const $backToBtn = $(e.currentTarget).parents('.menu-items');
        const $target = $backToBtn;
        const trigger = $target.data('target');
        const $trigger = $('.mobile-main-menu').find(
            '[data-trigger="' + trigger + '"]'
        );

        $target.removeClass('active');
        $trigger.parent().removeClass('active');

		$('.mobile-main-menu').removeClass('opened');

	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-article"]) return;
  try {
    
  $(document).scroll('scroll', function(event) {
    // Percent In View
    const percentInViewItems = $(".percent-in-view");

    const percentageObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const windowHeight = $(window).height()
        let percentage = entry.boundingClientRect.top / (entry.boundingClientRect.height * -1 + windowHeight)
        if (percentage >= 1) {
          percentage = 1
        }
        $(entry.target).css({ '--percent-in-view': percentage })
      })
    });

    percentInViewItems.each(item => {
      percentageObserver.observe(percentInViewItems[item])
    });
  });

  $('#videoModalOpen').click((event) => {
    const modalId = $(event.target).attr('modal-id');
    $('#videoModal[modal-id=' + modalId + ']').addClass('open');
  });
  $('#videoModalClose').click((event) => {
    const modalId = $(event.target).attr('modal-id');
    $('#videoModal[modal-id=' + modalId + ']').removeClass('open');
  });
  $('#videoModal').click((event) => {
    $(event.target).removeClass('open');
  });

  const sharePost = (url, width = 600, height = 700) => {
    if (window) {
      window?.open(url, 'targetWindow',
                   `toolbar=no,
                    location=no,
                    status=no,
                    menubar=no,
                    scrollbars=yes,
                    resizable=yes,
                    width=${ width },
                    height=${ height }`);
    }
  };

  $('*[share-url]').click((event) => {
    const shareUrl = $(event.target).attr('share-url');
    sharePost(shareUrl);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-product"]) return;
  try {
    
	$('.slick-slider').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
		if ($(this).parent().closest('#currentSlide')) {
			const currentSlide = $(this).parent().find('#currentSlide')[0];
			$(currentSlide).text(nextSlide + 1);
		}
	});
	$('.slick-slider').on('init', function(event, slick) {
		if ($(this).parent().closest('#slideCount')) {
			const currentSlide = $(this).parent().find('#slideCount')[0];
			$(currentSlide).text(slick.slideCount);
		}
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-workshop"] && !Shopify.designMode) return;
  try {
    
	$('button#addToCal').click(item => {
		const eventData = JSON.parse($(item.currentTarget).attr('data-event'));
		calendarLink.google(eventData);
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-levels"] && !Shopify.designMode) return;
  try {
    
	// In View
	const inViewItems = $(".set-in-view");
	// console.log(inViewItems)

	const inViewObserver = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) {
				entry.target.classList.add('in-view');
				inViewObserver.unobserve(entry.target);
			}
		})
	}, {
		threshold: .5
	});

	inViewItems.each(item => {
		inViewObserver.observe(inViewItems[item]);
	});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              if(window.lazyload) window.lazyload();
            }

            if (html.querySelector('.slick-slider.recommendations')) {
              this.classList.add('product-recommendations--loaded');
              $('.slick-slider.recommendations').slick().on('beforeChange', function(event, slick, currentSlide, nextSlide) {
                $(this).css({ '--progress': nextSlide });
              });
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-overlay"]) return;
  try {
    
	$('#mobileSearchClose').click(() => {
		$('#mobileSearch')[0].classList.remove('open');
	})

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !Shopify.designMode) return;
  try {
    
  $('.slick-slider').slick();
  $('.slick-slider.progress-dots').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
    $(this).css({ '--progress': nextSlide });
  });

  } catch(e) { console.error(e); }
})();
})();
